import { render } from "./LamanUtama.vue?vue&type=template&id=70b9acb6"
import script from "./LamanUtama.vue?vue&type=script&lang=js"
export * from "./LamanUtama.vue?vue&type=script&lang=js"

import "./LamanUtama.vue?vue&type=style&index=0&id=70b9acb6&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__